









































import throttle from 'lodash/throttle'
import Moment from 'moment-timezone/builds/moment-timezone-with-data-2012-2022'

export default {
  name: 'time-control',
  data() {
    return {
      context: undefined,
      wheelHeight: undefined,
      wheelWidth: undefined,
      pxRatio: window.devicePixelRatio || 1,
      lastMove: {},
      waitForRedraw: false,
      bigLabel: false,
      bigLabelDebounce: 0,
      stepInc: undefined,
      nstep: undefined,
      right: undefined,
      lastClick: new Date(0),
      daysMenu: false,
      pressed: false
    }
  },
  props: [
    'view-width',
    'shadow'
  ],
  mounted() {
    this.updateRight()
    this.$refs.handle.addEventListener('wheel', throttle(this.scrollMouseWheel, 100))
    this.wheelHeight = this.$refs.wheel.clientHeight * this.pxRatio
    this.wheelWidth = this.$refs.wheel.clientWidth * this.pxRatio
    this.$refs.wheel.height = this.wheelHeight
    this.$refs.wheel.width = this.wheelWidth
    this.nstep = this.wheelWidth / this.pxRatio / 2.5
    this.stepInc = (2 * Math.PI) / this.nstep
    this.context = this.$refs.wheel.getContext('2d')
    this.draw()
    window.addEventListener('keydown', this.keyScroll)
  },
  computed: {
    currentTime() {
      return this.$store.state.time.cursor
    },
    currentRun() {
      const run = this.$store.getters['time/run']
      return run.substring(6, 8) + '>' + run.substring(8) + 'Z' // run.replace(/(\d{4})(\d{2})(\d{2})(\d{2})/, '$1-$2-$3 $4Z')
    },
    currentZoneOffset() {
      const name = this.$store.state.persistent.timezone
      const zone = Moment.tz(name).format('Z')
      return 'UTC' + zone
    },
    roundedTime() {
      return this.$store.getters['time/roundedTime']
    },
    angle() {
      const hours = this.currentTime / (3600 * 1000)
      return hours * Math.PI * 2 / 12
    },
    run() {
      return this.$store.getters['time/run'].substring(8)
    },
    days() {
      const days = this.$store.state.time.segments.slice()
      days.reverse()
      return days
    },
    hours() {
      const hours = []
      for (let time = this.segment.startTime.valueOf(); time <= this.segment.stopTime.valueOf(); time += 30 * 60 * 1000) {
        hours.push(time)
      }
      return hours
    },
    segment() {
      return this.$store.getters['time/segment']
    },
    contributor() {
      return this.$store.getters['auth/isContributor']
    }
  },
  watch: {
    angle() {
      if (this.context !== undefined) {
        this.draw()
      }
    },
    viewWidth() {
      this.updateRight()
    },
    shadow() {}
  },
  methods: {
    seek(time) {
      this.daysMenu = false
      this.$store.dispatch('time/seek', time)
      this.showBigLabel()
    },
    beginMouseMove(e) {
      this.handleMenuClick()
      window.addEventListener('mousemove', this.mouseMove)
      window.addEventListener('mouseup', this.endMouseMove)
      window.addEventListener('mouseleave', this.endMouseMove)
      this.beginMove({ x: e.clientX, y: e.clientY })
    },
    beginTouchMove(e) {
      e.preventDefault()
      this.handleMenuClick()
      window.addEventListener('touchmove', this.touchMove)
      window.addEventListener('touchend', this.endTouchMove)
      window.addEventListener('touchleave', this.endTouchMove)
      this.beginMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
      this.bigLabel = true
      this.labelTimeoutArmed = false
    },
    endTouchMove() {
      window.removeEventListener('touchmove', this.touchMove)
      window.removeEventListener('touchend', this.endTouchMove)
      window.removeEventListener('touchleave', this.endTouchMove)
      this.labelTimeoutArmed = true
      setTimeout(() => {
        if (!this.labelTimeoutArmed) return
        this.bigLabel = false
        this.labelTimeoutArmed = false
      }, 500)
      this.endMove()
    },
    endMouseMove() {
      window.removeEventListener('mousemove', this.mouseMove)
      window.removeEventListener('mouseup', this.endMouseMove)
      window.removeEventListener('mouseleave', this.endMouseMove)
      this.endMove()
    },
    beginMove(origin) {
      this.pressed = true
      this.lastMove = origin
      this.$store.dispatch('runtime/showDragSurface')
    },
    doMove(e) {
      const x = e.x - this.lastMove.x
      this.lastMove = e
      // const y = Math.abs(this.moveOrigin.y - e.y)
      //  this.wheelTime += x / 120
      const secondes = x * 180
      // console.log(x, secondes)
      this.seek(secondes * 1000)
    },
    touchMove(e) {
      this.doMove({ x: e.touches[0].clientX, y: e.touches[0].clientY })
    },
    mouseMove(e) {
      this.doMove({ x: e.clientX, y: e.clientY })
    },
    endMove() {
      this.pressed = false
      this.$store.dispatch('runtime/hideDragSurface')
    },
    scrollMouseWheel(e) {
      if (e.deltaX > 0 || e.deltaY > 0) {
        this.seek(1 * 1800 * 1000)
      } else if (e.deltaX < 0 || e.deltaY < 0) {
        this.seek(-1 * 1800 * 1000)
      }
    },
    showBigLabel() {
      this.bigLabel = true
      this.bigLabelDebounce = new Date().valueOf()
      setTimeout(() => {
        if ((new Date()).valueOf() < this.bigLabelDebounce + 800) return
        this.bigLabel = false
        this.bigLabelDebounce = 0
      }, 800)
    },
    draw() {
      if (this.waitForRedraw) return
      this.waitForRedraw = true
      requestAnimationFrame(() => {
        const h = this.wheelHeight
        const w = this.wheelWidth

        this.context.clearRect(0, 0, w, h)
        let a = 0
        while (a < (2 * Math.PI)) {
          const centerSin = Math.sin(this.angle + a)
          const centerCos = Math.cos(this.angle + a)
          if (centerCos < 0) {
            a += this.stepInc
            continue
          }
          // if (centerSin < 0) continue;
          const ww = (centerCos * w) / this.nstep * 2
          if (a === 0) {
            this.context.fillStyle = `rgba(0, 85, 255, ${centerCos})`
          } else {
            this.context.fillStyle = `rgba(170, 170, 170, ${centerCos})`
          }
          // ctx.fillStyle = 'rgb(119, 119, 119)'
          // this.context.shadowColor = 'rgba(0, 0, 0, ' + centerCos + ')'
          this.context.fillRect(((w / 2) + ((centerSin * w) / 2)) - (ww / 2), 0, ww, h)
          a += this.stepInc
          this.waitForRedraw = false
        }
      })
    },
    updateRight() {
      if (this.$refs.control === undefined) this.right = undefined
      const right = (parseInt(this.viewWidth, 10) - this.$refs.control.clientWidth) / 2
      this.right = right + 'px'
    },
    handleMenuClick() {
      if (this.daysMenu) {
        this.daysMenu = false
      } else {
        setTimeout(() => {
          if (!this.pressed) {
            this.daysMenu = true
            this.$nextTick(() => {
              const hourLine =
              document.getElementsByClassName('active-hour')[0]
              try {
                hourLine.scrollIntoView()
                const parent = hourLine.parentNode
                const offset = 40 * 2
                if (parent.scrollTopMax > parent.scrollTop + offset) {
                  parent.scrollTop -= offset
                }
              } catch (e) {}
            })
          }
        }, 200)
      }
    },
    setDay(newDay) {
      const nDays = (newDay.startTime - this.segment.startTime) / 24 / 3600 / 1000

      // ugly hack
      // TODO : revoir système de segments
      const max = Math.abs(nDays)
      const delta = (nDays < 0 ? -24 : 24) * 3600 * 1000
      for (let i = 0; i < max; i++) {
        this.seek(delta)
      }
    },
    setHour(newHour) {
      const delta = newHour - this.currentTime
      this.seek(delta)
    },
    keyScroll(e) {
      if (this.$store.state.runtime.modal) return
      switch (e.key) {
        case 'ArrowLeft':
          this.seek(-30 * 60 * 1000)
          break
        case 'ArrowRight':
          this.seek(30 * 60 * 1000)
          break
        default:
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/time-control.vue